import { useState, type FormEvent } from 'react';

interface LoginPageProps {
  pending: boolean;
  error: string | null;
  onLogin: (login: string, password: string) => void;
}

export function LoginPage({ pending, error, onLogin }: LoginPageProps) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    onLogin(login, password);
  };

  return (
    <main className="auth-page">
      <section className="auth-card">
        <div className="auth-brand">
          <span className="brand-mark">Р</span>
          <div>
            <strong>Рабочий чат</strong>
            <small>Общение вашей команды</small>
          </div>
        </div>
        <div className="auth-intro">
          <span>Добро пожаловать</span>
          <h1>Войдите в рабочий чат</h1>
          <p>Логин и пароль выдаёт руководитель.</p>
        </div>
        <form onSubmit={submit} className="auth-form">
          <label>
            Логин
            <input
              autoComplete="username"
              autoFocus
              value={login}
              onChange={(event) => setLogin(event.target.value)}
              required
            />
          </label>
          <label>
            Пароль
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>
          {error && <p className="form-error">{error}</p>}
          <button className="primary-button" disabled={pending}>
            {pending ? 'Входим…' : 'Войти'}
          </button>
        </form>
        <footer>Данные хранятся на вашем сервере</footer>
      </section>
      <aside className="auth-visual">
        <div className="privacy-orbit">
          <span>🔒</span>
          <i />
          <i />
          <i />
        </div>
        <h2>Вся команда на связи</h2>
        <p>Личные сообщения, рабочие группы и файлы в одном простом приложении.</p>
      </aside>
    </main>
  );
}
